import * as React from 'react';
import { connect } from 'react-redux';

// Components
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { Panel } from '../../../../components/Layout/Panel';
import { Screen } from '../../../../components/Layout/Screen';
import Title, { Subtext } from '../../../../components/Title';

// Assets
import { device } from '../../../../styles/variables';
import panel from '../../../../assets/images/pages/patient-hope/man-boy-in-snow.png';

const tabletRotated = `only screen and ${device.tablet} and (orientation : landscape)`;
const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: url(${panel}) no-repeat center;
  background-size: cover;
  padding-top: 1px;
  margin-top: -1px;
  background-position-y: 0;

  @media ${device.mobile} {
    background-position-y: -220px;
  }

  .title {
    padding: 20px;
    @media ${device.tablet} {
      padding: 40px;
    }
    @media ${device.laptop} {
      padding: 20px;
    }

    h2 {
      max-width: 100%;
    }

    .subtext {
      max-width: 100%;
      font-size: 16px;
      line-height: 36px;
    }
  }

  .panel {
    width: 100%;
    height: 48%;
    @media ${device.mobileL} {
      height: 40%;
    }
    @media ${device.tablet} {
      width: 60%;
      height: 50%;
    }
    @media ${tabletRotated} {
      width: 100%;
    }
    @media ${device.laptop} {
      height: 37%;
    }
    @media ${device.laptopL} {
      width: 40%;
      height: 50%;
    }
  }
`;

const UnmetNeedsScreen = () => (
  <StyledScreen>
    <ContentContainer>
      <Panel className="panel" top="unset" bottom="0">
        <Title primary={false} className="title">
          Unmet need
          <br />
          <Subtext className="subtext">
            We were struck by the unmet need in the disease area, and the stories of patients who
            were frequently hospitalised with little hope of an effective treatment. In order to
            hear the patient voice throughout the modules, and therefore to engage and motivate the
            audience, we re-edited the client’s existing videos to create short and powerful
            snapshots of life with AD.
          </Subtext>
        </Title>
      </Panel>
    </ContentContainer>
  </StyledScreen>
);

export default connect()(UnmetNeedsScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/AdvocatingForPatientsHope/screens/UnmetNeeds.jsx